export const createCustomError = (message, name) =>
  new (class extends Error {
    constructor(message, name) {
      super(message);
      this.name = name;
    }
  })(message, name);
